import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import styels from "../../styles/components/verifyconfirmwebsitefilter.module.scss";
import modalstyle from "../../styles/layout/modal/verifyconfirmwebsitemodal.module.scss";

import CalenderIcon from "../../public/assets/icons/CalenderIcon";
import FilterIcon from "../../ui/Icons/FilterIcon";
import MuiModalWrapper from "../../ui/Modal/MuiModalWrapper";
import RefreshIconBlack from "../../ui/Icons/RefreshIconBlack";
import RefreshIconBlue from "../../ui/Icons/RefreshIconBlue";
import SelectDropDown from "../../ui/Icons/SelectDropDown";
import ResetIcon from "../../public/assets/icons/ResetIcon";
import AlltimemenuTwo from "../../ui/Customdropdown/AlltimemenuTwo";
import dropdownStyles from "../../lib/functions/dropwdownstyles";
import useFetch from "../../hooks/api/useFetch";
import {
  countryData,
  getMonthQueryRange,
  sampleMonthsValueArray,
  sampleYearList,
} from "../../lib/functions/utils.lib";
import dayjs from "dayjs";
import { useEffect } from "react";
import CalenderDate from "../../pages/Calender";
import useCalenderFilter from "../../hooks/useCalenderFilter";

const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",

    [`.MuiDialog-paper`]: {
      marginTop: "72px",
      boxShadow: "none",
      borderRadius: "10px !important",
      [`.MuiDialogContent-root`]: {
        padding: "0 11px",
      },
    },
  },
};

const Aquisitorvalues = [
  {
    name: "Theodore",
    degisnation: "Member",
  },
  {
    name: "Muhammad Ali Waqas ",
    degisnation: "Partner",
  },
  {
    name: "Maxime Barronier",
    degisnation: "Partner",
  },
  {
    name: "Avraam",
    degisnation: "Member",
  },
  {
    name: "Awais",
    degisnation: "Content Buyer",
  },
];

export default function VerifyConfrmWebsiteFilter({
  totalVideos,
  currentFilterParams,
  setCalenderDate,
  handleDateFilter,
  handleFilter,
  videoCountry,
  setVideoCountry,
  buyerId,
  setBuyerId,
}) {
  //calender functions
  const calenderId = "calendar-input-home";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderId,
  });
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [acquisitor, setAcquisitor] = React.useState("");
  const [acquisitorId, setAcquisitorId] = React.useState(buyerId);

  const handleChangeAcquisitor = (event) => {
    console.warn(event.target.value);
    setAcquisitor(event.target.value.full_name);
    setAcquisitorId(event.target.value.value);
  };

  const [month, setMonth] = React.useState("");

  const handleChangeMonth = (event) => {
    setMonth(event.target.value);
  };

  const [year, setYear] = React.useState("");

  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };

  const [location, setLocation] = React.useState(
    videoCountry ? videoCountry : ""
  );

  const handleChangeLocation = (event) => {
    setLocation(event.target.value);
  };

  const [filterParams, setFilterParams] = React.useState({
    has_note: "",
    show_potential_duplicates: "",
    purchased_assets: "",
    has_pending_message: "",
    unreachable_submitter: "",
    people_appearing: "",
    person_who_filmed: "",
    submit_other_website: "",
    aggrement_with_another_company: "",
    filter_active: false,
  });

  const resetFilter = () => {
    setFilterParams({
      has_note: "",
      show_potential_duplicates: "",
      purchased_assets: "",
      has_pending_message: "",
      unreachable_submitter: "",
      people_appearing: "",
      person_who_filmed: "",
      submit_other_website: "",
      aggrement_with_another_company: "",
      filter_active: false,
    });
    setMonth("");
    setYear("");
    setLocation("");
  };

  const {
    data: allUsers,
    isLoading,
    isSuccess,
  } = useFetch(["users-list"], "manager/users");

  const handleResetSingleField = (name) => {
    setFilterParams((prev) => {
      return { ...prev, [name]: "" };
    });
  };

  const handleFilterParamChange = (event) => {
    const { name, value } = event.target;
    setFilterParams((prev) => {
      return {
        ...prev,
        [name]: value,
        filter_active: true,
      };
    });
  };
  const submitFilter = () => {
    handleFilter({
      ...filterParams,
    });
    const dates = getMonthQueryRange(month, year, "obj");
    if (dates) {
      handleDateFilter({
        startDate: dates.from_date,
        endDate: dates.to_date,
      });
    }
    setBuyerId(acquisitorId);
    setVideoCountry(location);
    handleClose();
  };
  useEffect(() => {
    if (currentFilterParams === null) {
      resetFilter();
      setBuyerId("");
      setVideoCountry("");
    }
  }, [currentFilterParams]);
  useEffect(() => {
    const startDate = dayjs(confirmedCalenderValue?.[0]).format("DD-MM-YYYY");
    const endDate = dayjs(confirmedCalenderValue?.[1]).format("DD-MM-YYYY");
    setCalenderDate({ from: startDate, to: endDate });
  }, [confirmedCalenderValue]);

  return (
    <>
      <Box className={styels.editorFilterWrapper}>
        <Box
          className={`${styels.editorFilterWrapperTxt} ${
            filterParams?.filter_active ? `${styels.filterHighlight}` : ""
          }`}
        >
          <Typography
            variant="body1"
            className={`${
              calenderFilter?.name?.length ? "" : `${styels.datePeriod}`
            }`}
          >
            Showing videos for{" "}
            {calenderFilter?.name?.length ? "" : "the period from"}
          </Typography>
          <AlltimemenuTwo
            filterParams={filterParams}
            dateRangeFilterAnchor={dateRangeFilterAnchor}
            DateFilterRangeList={DateFilterRangeList}
            openedDateRangeFilter={openedDateRangeFilter}
            handleCloseDateRangeFilter={handleCloseDateRangeFilter}
            changeCalenderFilter={changeCalenderFilter}
            calenderFilter={calenderFilter}
            handleOpenDateRangeFilter={handleOpenDateRangeFilter}
          />
          <Typography
            variant="body1"
            className={`${styels.dateShow} ${
              calenderFilter?.name?.length ? "" : `${styels.textBlue}`
            }`}
          >
            {filterParams?.filter_active ? (
              "one or more selected filters"
            ) : calenderFilter?.name?.length ? (
              `(${dayjs(confirmedCalenderValue?.[0]).format("LL")} - ${dayjs(
                confirmedCalenderValue?.[1]
              ).format("LL")})`
            ) : (
              <>
                {/* {"the period from "} */}
                {confirmedCalenderValue?.[0] ? (
                  <span className="dayList">
                    {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                  </span>
                ) : null}
                {" to "}
                {calenderValue?.[1] ? (
                  <span className="dayList">
                    {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                  </span>
                ) : null}
              </>
            )}
          </Typography>
          {calenderFilter?.name !== "All time" ? (
            <Button
              type="text"
              className={styels.reset_btn}
              onClick={resetCalender}
            >
              <Typography variant="caption" className={styels.ico}>
                <ResetIcon />
              </Typography>
              <Typography variant="caption" className={styels.text}>
                reset
              </Typography>
            </Button>
          ) : null}
        </Box>

        <Box className={styels.editorFilterButtonGroup}>
          <Button className={styels.calenderBtn} onClick={handleOpen}>
            <FilterIcon />{" "}
          </Button>
          <CalenderDate confirmCalender={confirmCalenderTwo} />
          <Button className={styels.allVideo}>
            All videos: <span>{totalVideos}</span>
          </Button>
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "787px",
            position: "relative",
          },
        }}
        sx={dialogContainer}
      >
        <DialogContent>
          <Box className={modalstyle.dialog_wrapper}>
            <Box className={modalstyle.dialog_top}>
              <Typography variant="h3" className={modalstyle.heading}>
                Filter
              </Typography>
              <Button
                type="button"
                className={modalstyle.refresh_btn}
                onClick={resetFilter}
              >
                <Typography variant="caption" className={modalstyle.icon}>
                  <RefreshIconBlack />
                </Typography>
                <Typography variant="caption" className={modalstyle.text}>
                  Clear
                </Typography>
              </Button>
            </Box>
            <Box className={modalstyle.dialog_middle}>
              <Box className={modalstyle.form_wrapper}>
                <form>
                  <Box className={modalstyle.form_one}>
                    <Box className={modalstyle.form_row}>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.groupAcquisitor}`}
                      >
                        <label>
                          <Typography variant="caption">Acquisitor</Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => {
                              setAcquisitor("");
                              setAcquisitorId("");
                            }}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.input_group}>
                          <Select
                            value={acquisitor}
                            onChange={handleChangeAcquisitor}
                            MenuProps={{
                              PaperProps: {
                                sx: dropdownStyles(134),
                              },
                            }}
                            renderValue={() => {
                              if (!acquisitor?.length) {
                                return <span>None</span>;
                              } else {
                                return <span>{acquisitor}</span>;
                              }
                            }}
                          >
                            {allUsers?.data?.data.map((aqs, index) => {
                              return (
                                <MenuItem
                                  value={{
                                    full_name: `${aqs?.name ? aqs?.name : ""} ${
                                      aqs?.last_name ? aqs?.last_name : ""
                                    }`,
                                    value: aqs?.id,
                                  }}
                                  key={index}
                                >
                                  {`${aqs?.name ? aqs?.name : ""} ${
                                    aqs?.last_name ? aqs?.last_name : ""
                                  }`}
                                  <span>
                                    &nbsp;(
                                    {aqs?.role?.display_name})
                                  </span>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </Box>
                      </Box>

                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.groupFilmedIn}`}
                      >
                        <label>
                          <Typography variant="caption">Filmed in</Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => {
                              setMonth("");
                              setYear("");
                            }}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.select_wrap}>
                          <Box
                            className={`${modalstyle.input_group} ${modalstyle.input_month}`}
                          >
                            <Select
                              displayEmpty
                              value={month}
                              onChange={handleChangeMonth}
                              MenuProps={{
                                PaperProps: {
                                  sx: dropdownStyles(134, true),
                                },
                              }}
                              renderValue={() => {
                                if (!month?.length) {
                                  return <span>None</span>;
                                } else {
                                  return <span>{month}</span>;
                                }
                              }}
                            >
                              <MenuItem value="">Month</MenuItem>
                              {sampleMonthsValueArray.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                  {item.month}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                          <Box
                            className={`${modalstyle.input_group} ${modalstyle.input_year}`}
                          >
                            <Select
                              value={year}
                              displayEmpty
                              onChange={handleChangeYear}
                              MenuProps={{
                                PaperProps: {
                                  sx: dropdownStyles(134, true),
                                },
                              }}
                              renderValue={() => {
                                if (!year?.length) {
                                  return <span>None</span>;
                                } else {
                                  return <span>{year}</span>;
                                }
                              }}
                            >
                              <MenuItem value="">Year</MenuItem>
                              {sampleYearList.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                        </Box>
                      </Box>

                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.groupFilmedLocation}`}
                      >
                        <label>
                          <Typography variant="caption">
                            Filming Location
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => setLocation("")}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.input_group}>
                          <Select
                            value={location}
                            onChange={handleChangeLocation}
                            MenuProps={{
                              PaperProps: {
                                sx: dropdownStyles(134),
                              },
                            }}
                            renderValue={() => {
                              if (!location?.length) {
                                return <span>None</span>;
                              } else {
                                return <span>{location}</span>;
                              }
                            }}
                          >
                            {countryData.map((item, index) => (
                              <MenuItem
                                key={index}
                                value={`${item.name} (${item.code})`}
                              >
                                {`${item.name} (${item.code})`}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      className={`${modalstyle.form_row} ${modalstyle.radio_row}`}
                    >
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.hasGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">Has Notes?</Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() => handleResetSingleField("has_note")}
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            value={filterParams.has_note}
                            name="has_note"
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.unreachGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">
                            Unreachable Owner?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField("unreachable_submitter")
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box
                          className={modalstyle.radio_group}
                          name="unreachable_submitter"
                          value={filterParams.unreachable_submitter}
                          onChange={handleFilterParamChange}
                        >
                          <RadioGroup row>
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.purchaseGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">
                            Purchased Assets?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField("purchased_assets")
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            name="purchased_assets"
                            value={filterParams.purchased_assets}
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                      <Box
                        className={`${modalstyle.form_group} ${modalstyle.pendingGroup}`}
                      >
                        <label className={modalstyle.innerLabel}>
                          <Typography variant="caption">
                            Has Pending Message
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField("has_pending_message")
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            name="has_pending_message"
                            value={filterParams.has_pending_message}
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box className={modalstyle.form_two}>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Are There People Appearing In The Video?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField("people_appearing")
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            name="people_appearing"
                            value={filterParams.people_appearing}
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            The Person Who Filmed This Video Is:
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField("person_who_filmed")
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            name="person_who_filmed"
                            value={filterParams.person_who_filmed}
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="Me"
                              control={<Radio />}
                              label="Me"
                            />
                            <FormControlLabel
                              value="A Family Member"
                              control={<Radio />}
                              label="A Family Member"
                            />
                            <FormControlLabel
                              value="A Friend"
                              control={<Radio />}
                              label="A Friend"
                            />
                            <FormControlLabel
                              value="Someone I Know"
                              control={<Radio />}
                              label="Someone I Know"
                            />
                            <FormControlLabel
                              value="A Dashcam"
                              control={<Radio />}
                              label="A Dashcam"
                            />
                            <FormControlLabel
                              value="A Security Camera"
                              control={<Radio />}
                              label="A Security Camera"
                            />
                            <FormControlLabel
                              value="Other: the kid of my friend"
                              control={<Radio />}
                              label={
                                <>
                                  Other: <span>the kind of my friend</span>
                                </>
                              }
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Did You Send/Submit/Upload This Video To A Website
                            And/Or Social Media Account?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField("submit_other_website")
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            name="submit_other_website"
                            value={filterParams.submit_other_website}
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="No, I Did Not"
                              control={<Radio />}
                              label="No, I Did Not"
                            />
                            <FormControlLabel
                              value="Yes, Another Company's Website"
                              control={<Radio />}
                              label="Yes, Another Company's Website"
                            />
                            <FormControlLabel
                              value="Yes, A Facebook Page"
                              control={<Radio />}
                              label="Yes, A Facebook Page"
                            />
                            <FormControlLabel
                              value="Yes, A Twitter Account"
                              control={<Radio />}
                              label="Yes, A Twitter Account"
                            />
                            <FormControlLabel
                              value="Yes, An Instagram Account"
                              control={<Radio />}
                              label="Yes, An Instagram Account"
                            />
                            <FormControlLabel
                              value="Yes, A YouTube Channel"
                              control={<Radio />}
                              label="Yes, A YouTube Channel"
                            />
                            <FormControlLabel
                              value="Yes, A Snaphat Account"
                              control={<Radio />}
                              label="Yes, A Snaphat Account"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                    <Box className={modalstyle.form_row}>
                      <Box className={modalstyle.form_group}>
                        <label>
                          <Typography variant="caption">
                            Did You Sign A Licensing Agreement For This Video
                            With Another Company/Page?
                          </Typography>
                          <Button
                            type="button"
                            className={modalstyle.refresh_btn}
                            onClick={() =>
                              handleResetSingleField(
                                "aggrement_with_another_company"
                              )
                            }
                          >
                            <RefreshIconBlue />
                          </Button>
                        </label>
                        <Box className={modalstyle.radio_group}>
                          <RadioGroup
                            row
                            name="aggrement_with_another_company"
                            value={filterParams.aggrement_with_another_company}
                            onChange={handleFilterParamChange}
                          >
                            <FormControlLabel
                              value="No, I Did Not"
                              control={<Radio />}
                              label="No, I Did Not"
                            />
                            <FormControlLabel
                              value="Yes, I Have Filled An Online Form"
                              control={<Radio />}
                              label="Yes, I Have Filled An Online Form"
                            />
                            <FormControlLabel
                              value="Yes, I Have Signed An Exclusive Agreement"
                              control={<Radio />}
                              label="Yes, I Have Signed An Exclusive Agreement"
                            />
                            <FormControlLabel
                              value="Yes, I Have Signed A Non-Exclusive Agreement"
                              control={<Radio />}
                              label="Yes, I Have Signed A Non-Exclusive Agreement"
                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </form>
              </Box>
            </Box>

            <Box className={modalstyle.dialog_bottom}>
              <Box className={modalstyle.btn_holder}>
                <Button
                  type="button"
                  className={modalstyle.cancel_btn}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  className={modalstyle.submit_btn}
                  onClick={submitFilter}
                >
                  Filter <strong>now</strong>
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
